module.exports = __webpack_public_path__ + "static/media/main.2522b270.scss";


//////////////////
// WEBPACK FOOTER
// ./src/scss/main.scss
// module id = 45
// module chunks = 0